/** Bir riser setinin beş hattı; sıra ekrandaki ve mesajlardaki sıradır (tamir.service hat özeti de bunu kullanır). */
export const SET_HATLARI = ["Main", "Choke", "Kill", "Booster", "Hydraulic"];
export const setHatMi = (h) => SET_HATLARI.includes(h);
/**
 * NDT raporu `dokuman` tablosunda `aile = "NDT"` + `hat` + `kaynakEkran = "assembly"` ile durur. İkisi birden aranır:
 * rotadaki NDT adım raporları (aile = adım adı, kaynak ekran komponent) hat şartını karşılamaz (Bekir kararı 29.09.2026).
 */
export const NDT_AILE = "NDT";
export const NDT_KAYNAK_EKRAN = "assembly";
export const ndtBelgesiMi = (d) => d.aile === NDT_AILE && d.kaynakEkran === NDT_KAYNAK_EKRAN;
/**
 * "No record available" (NDT) işaretleme ve kaldırma yetkisi: rotadaki kalite kapısı atlamasıyla aynı (kalite lideri; PM ve
 * sistem yöneticisi her işte yetkili). NDT raporunu yükleme ve kaldırma "evrak" yetkisindedir. Gerekçe isteğe bağlı
 * (D-043).
 */
export const NDT_KAYIT_YOK_YETKI = "kayitYokKapi";
/**
 * Assembly raporu yüklüyken riserin NDT tarafı tamamen donar: ekleme, dosya kaldırma, işaretleme ve işaret kaldırma
 * yapılamaz; değişiklik için önce Assembly raporu kaldırılır (Bekir kararı 29.09.2026). `false` olsaydı yalnız
 * kaldırmalar donardı.
 */
export const ASM_NDT_EKLEMEYI_DONDURUR = true;
/**
 * NDT'si eksik hatlar, SET_HATLARI sırasında. Hat, en az bir NDT raporu ya da etkin "No record available" işareti varsa
 * tamamdır. Girdide olmayan hat eksik sayılır; beş hattın dışındaki adlar yok sayılır.
 */
export function ndtEksikHatlar(h) {
    return SET_HATLARI.filter((s) => !h.some((x) => x.hat === s && (x.ndtSayisi > 0 || x.kayitYok)));
}
/** Assembly raporu (FM-0012) yüklemesinin NDT engeli; boş string = yüklenebilir. Mesaj eksik hatları sayar ve adlandırır. */
export function asmNdtEngeli(eksik) {
    if (!eksik.length)
        return "";
    return `Assembly report upload is blocked: NDT report missing on ${eksik.length} of ${SET_HATLARI.length} lines (${eksik.join(", ")}). Upload the NDT report or tick “No record available” on each line.`;
}
/** Bir hattın NDT kanıtını değiştiren işlemin kilidi; boş string = yapılabilir. `asmVar`: riserin Assembly raporu yüklü mü. */
export function ndtKilitEngeli(asmVar, islem) {
    if (!asmVar)
        return "";
    if (!ASM_NDT_EKLEMEYI_DONDURUR && (islem === "ekle" || islem === "isaretle"))
        return "";
    return "Remove the Assembly report first; while it is uploaded a line's NDT evidence cannot be changed.";
}
//# sourceMappingURL=set.js.map